import { useCallback, useEffect, useState } from "react";

import apiV2 from "../../../services/apiV2";

const DEFAULT_PAGE_SIZE = 20;
const SEARCH_DEBOUNCE_MS = 400;

export default function useAsaasTransactions({
	status,
	period,
	searchParam,
	pageNumber,
}) {
	const [debouncedSearch, setDebouncedSearch] = useState(searchParam);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const [summary, setSummary] = useState({
		total: 0,
		pending: 0,
		received: 0,
		receivedAmountMonth: 0,
	});
	const [transactions, setTransactions] = useState([]);
	const [count, setCount] = useState(0);
	const [hasMore, setHasMore] = useState(false);

	useEffect(() => {
		const timer = setTimeout(() => setDebouncedSearch(searchParam), SEARCH_DEBOUNCE_MS);
		return () => clearTimeout(timer);
	}, [searchParam]);

	const load = useCallback(async () => {
		setLoading(true);
		setError(null);
		try {
			const { data } = await apiV2.get("/asaas/transactions", {
				params: {
					status: status === "all" ? "" : status,
					period,
					searchParam: debouncedSearch || undefined,
					pageNumber,
					pageSize: DEFAULT_PAGE_SIZE,
				},
			});
			setSummary(data.summary || {});
			setTransactions(data.transactions || []);
			setCount(data.count || 0);
			setHasMore(Boolean(data.hasMore));
		} catch (err) {
			setError(err);
			setTransactions([]);
			setCount(0);
			setHasMore(false);
		} finally {
			setLoading(false);
		}
	}, [status, period, debouncedSearch, pageNumber]);

	useEffect(() => {
		load();
	}, [load]);

	return {
		loading,
		error,
		summary,
		transactions,
		count,
		hasMore,
		pageSize: DEFAULT_PAGE_SIZE,
		reload: load,
	};
}

export async function fetchTransactionDetail(id) {
	const { data } = await apiV2.get(`/asaas/transactions/${id}`);
	return data;
}
